// extracted by mini-css-extract-plugin
export default {"Tabs":"Tab_Tabs__XRDmn","nav":"Tab_nav__URNIT","active":"Tab_active__cfVbZ","disabled":"Tab_disabled__Sh1lM"};